<template>
  <CourseDetailPage :key="$route.query.id" preview />
</template>

<script>
import CourseDetailPage from '@/components/Course/CourseDetailPage.vue';

export default {
  name: 'MarketSimplePage',
  components: { CourseDetailPage }
};
</script>
